module.exports = __webpack_public_path__ + "img/icon_map_38_on_101.60c8b133.png";